import { Signatures } from '../signature'
import { fetchImageAsBase64WithDimensions } from './fetchImage'

/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 */
export const fetchSignaturess = constructionLog => {
  return Promise.all(constructionLog.log_pages.map(page =>
    fetchSignatures(page)
  ))
}

/**
 * @param {import('../constructionLog').LogPage} page
 * @returns {Promise<Signatures>}
 */
const fetchSignatures = page => {
  /**
   * @param {string} path 
   * @returns {Promise<ImageBase64WithDimensions | null>}
   */
  let maybeFetch = path => (path === '' || path === 'none') ?
    new Promise(r => r(null)) :
    fetchImageAsBase64WithDimensions('/storage/' + path)
  return Promise.all([
    maybeFetch(page.ncontractor_sign),
    maybeFetch(page.contractor_sign),
    maybeFetch(page.supervisor_sign)])
    .then(arr => new Promise(resolve =>
      resolve(new Signatures(arr[0], arr[1], arr[2]))
    ))
}